import { useI18nContext } from "@hopper-b2b/i18n";
import { PillTone } from "@tenant/ui";
import { COMPLETED_KEY, PRODUCT_STATUS_CONFIGS } from "./productStatusConfigs";
import type { TripsReservationStatusPillProps } from "./types";

export const useTripsReservationStatusPill = (
  props: TripsReservationStatusPillProps
) => {
  const { t } = useI18nContext();
  const { variant, status, isPastTrip = false, scheduleChangeSeverity } = props;

  if (status == null) {
    return null;
  }

  const config = PRODUCT_STATUS_CONFIGS[variant];
  if (!config) {
    return { tone: PillTone.neutral, label: t("unknown") };
  }

  // Check if there's a custom resolver (e.g., for flight schedule changes)
  if (config.customResolver) {
    const customResult = config.customResolver({
      status,
      isPastTrip,
      scheduleChangeSeverity,
      t,
    });
    if (customResult) {
      return customResult;
    }
  }

  // Build the status map
  const statusMap = config.buildStatusMap(t);

  // Past trips that aren't terminal (cancelled/failed) show as "Completed"
  if (isPastTrip && !config.terminalStatuses.includes(status)) {
    return statusMap[COMPLETED_KEY];
  }

  // Return mapped status or fallback to raw status string
  return statusMap[status] ?? { tone: PillTone.neutral, label: status };
};
